(function (global) {
    if (global.rlModule.rlPackModule) {
        console.log('rlPackModule is defined!');
        return;
    }

    global.rlModule.rlPackModule = (function () {
        var _module = {};

        var _rlServerConfigPath = '/includes/script/modules/rlServerConfig.js';
        var _requiredFilePaths = [
            '/includes/script/plugin/lz-string/lz-string.min.js',
            '/includes/script/modules/RLGlobal_Variable.js'];

        var _productdesc = {};
        var _productprice = {};

        var pageType = {
            "ic": 0,
            "ct": 1,
            "aud": 2,
            "cta": 3,
            "cc": 4
        }

        var modelPolygonSizeEnum = {
            LOW: 1,
            MID: 2,
            HIGH: 3,
        };
    
        var textureResolutionEnum = {
            LOW: 1,
            MID: 2,
            HIGH: 3,
        };

        var iconListTypeEnum = {
            SPEC: 0,
            ATTRIBUTE: 1
        }

        var displayMessageTypeForDiscontinuedContentEnum = {
            SHOW_DEFAULT_MESSAGE: 0,
            SHOW_PROMOTION: 1,
            HIDDEN: 2
        }

        var urlDomain = "https://www.reallusion.com/";
        var websiteName = "contentstore/";

        let textInfo = {};

        let pageInfoData = {};

        const apiUrl = {
            wishList: "ContentData/v2/User/WishList/",
            detailInfo: "ContentData/v2/Pack/DetailInfo"
        }

        $(function () {
            _productdesc = $("._productdesc");
            _productprice = $("._productprice");
            var _contentPid = $(".rl-contentpackprice[data-content-pid]");
            if ((_productdesc.length > 0) || (_productprice.length > 0) && _contentPid.length == 0) {
                _module.bindPackInfo();
            }
        });

        var shiftPriceAreaWhenScroll = function () {
            if (_productdesc.length <= 0) {
                return;
            }

            let timeoutId;

            function shiftPriceArea () {
                //set _productprice width
                _productprice.find(".contentpack-info").addClass('contentpack-info--on-main-banner');
                const positionOfShiftPriceArea = _productdesc.offset().top - $(window).outerHeight(true);
                if (window.innerWidth > 767 && ($(global).scrollTop() >= positionOfShiftPriceArea)) {
                    _productdesc.find('._product-price').append($('.rl-contentpackprice'));

                    //set _productdesc sticky top
                    let topnavHeight = $('#topnavarea').height() || 60;
                    _productdesc.find("._productprice").css({'top': `${topnavHeight + 18}px`});
                    //remove _productprice class(width in desc is wider than in banner)
                    _productprice.find(".contentpack-info").removeClass('contentpack-info--on-main-banner');
                }
                else if ($('._product-price .rl-contentpackprice').length > 0) {
                    _productdesc.find(".rl-contentpackprice").insertAfter(".product-price-flag");
                }
            }
            //inset flag for insert price　use
            $('<div class="product-price-flag"></div>').insertBefore($('.rl-contentpackprice'));

            shiftPriceArea();
            $(global).on('scroll', function() {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                timeoutId = setTimeout(shiftPriceArea, 100);
            });
        }

        //get url param
        var getURLParameter = function (name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

        var deleteWishList = function (contentID) {
            return $.ajax({
                xhrFields: {
                    withCredentials: true,
                },
                type: "DELETE",
                url: rlServerURL.API + apiUrl.wishList,
                data: JSON.stringify({'contentIDs': [contentID]}),
                headers: {
                    "Content-Type": "application/json",
                }
            })
        }

        var addWishList = function (contentID) {
            return $.ajax({
              xhrFields: {
                withCredentials: true,
              },
              type: "POST",
              url: rlServerURL.API + apiUrl.wishList,
              data: JSON.stringify({ contentID: contentID }),
              headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Compress-Output": "false",
              }
            })
          };

        var setWishListIconState = function (active) {
            if (active) {
                document.querySelectorAll('.wishlist-icon').forEach(function(element) {
                    element.classList.add('active');
                    const parentElement = element.closest('.svg-icon-wrapper');
                    if (parentElement) {
                        parentElement.setAttribute('title', 'Delete from Wishlist');
                    }
                });
            } else {
                document.querySelectorAll('.wishlist-icon').forEach(function(element) {
                    element.classList.remove('active');
                    const parentElement = element.closest('.svg-icon-wrapper');
                    if (parentElement) {
                        parentElement.setAttribute('title', 'Add to Wishlist');
                    }
                });
            }
        }

        _module.toggleWishListButton = function () {
            if (!rlTopNav) { return; }

            if (rlTopNav.isLogin) {
                if (pageInfoData.CSItem.InWishList) {
                    deleteWishList(pageInfoData.CSItem.ContentID)
                    .then(function (response) {
                        if (response.ReturnCode == RLReturnCode.OperateSuccess.value) {
                            pageInfoData.CSItem.InWishList = false;
                            setWishListIconState(pageInfoData.CSItem.InWishList);
                            rlTopNav.updateMenuWishListNumber();
                        }
                    })
                }
                else {
                    addWishList(pageInfoData.CSItem.ContentID)
                    .then(function (response) {
                        if (response.ReturnCode == RLReturnCode.OperateSuccess.value) {
                            pageInfoData.CSItem.InWishList = true;
                            setWishListIconState(pageInfoData.CSItem.InWishList);
                            rlTopNav.updateMenuWishListNumber();
                        }
                    })
                }
            }
            else {
                rlTopNav.login();
            }
        }

        _module.popupShareDialog = function () {
            $.magnificPopup.open({
                items: {
                    src: "#share-panel",
                    type: 'inline',
                }
            });
        }

        _module.bindPackInfo = function (data) {
            _productdesc = $("._productdesc");
            _productprice = $("._productprice");
            
            function renderLayout(response) {
                var packinfo = response;
                if (packinfo.ReturnCode == RLReturnCode.OperateSuccess.value) {
                    pageInfoData = packinfo.ReturnData;

                    textInfo = _module.getRequiredVersionAndBuyButtonText({
                        MKPInfo: pageInfoData.CSItem.MKPInfo,
                        RequiredVersions: pageInfoData.RequiredVersions,
                    });

                    if (_productprice.length > 0) {
                        renderProductPriceUI("/includes/rl-modules/wpt/v1/rlcontentpackprice-tpl.html", packinfo.ReturnData);
                    }
                    if (_productdesc.length > 0) {
                        renderProductDescUI("/includes/rl-modules/wpt/v1/product-description.html", packinfo.ReturnData);
                        if (getURLParameter("detail")) {
                            setTimeout(() => {
                                $("html, body").animate(
                                    {
                                        scrollTop: $("._productdesc-area ._productdesc-desc").offset().top + $("._productdesc-area ._productdesc-desc").outerHeight() - $(window).height() * 0.5
                                    },
                                    1000
                                );
                            }, 1000);
                        }
                    }
                }
                else {
                    var errorMsg = '';
                    switch (response.ReturnCode) {
                        case RLReturnCode.DBError.value:
                            errorMsg = 'DB error.';
                            break;
                        case RLReturnCode.IDNoDataFound.value:
                            errorMsg = 'No data.';
                            break;
                        case RLReturnCode.OperateFail.value:
                            errorMsg = 'Operate fail';
                            break;
                        case RLReturnCode.NotAuth.value:
                            errorMsg = 'Not auth.';
                            break;
                        case RLReturnCode.ParamError.value:
                            errorMsg = 'Param error.';
                            break;
                        default:
                            errorMsg = 'unknow fail.';
                            break;
                    }
                }
            }

            if (typeof(data) === "object") {
                $.when(_loadScript()).then(function () {
                    renderLayout(data);
                });
            }
            else {
                var deferred = $.Deferred();
                $.when(_loadScript()).then(function () {
                    var _apiURL = rlServerURL.API + apiUrl.detailInfo + "?RequestUrl=" + window.location.href;
                    var param = {
                        preview: false
                    };
                    urlDomain = rlServerURL.MainWeb;
                    
                    $.ajax({
                        type: "GET",
                        url: _apiURL,
                        contentType: "application/json",
                        dataType: "json",
                        data: param,
                        xhrFields: {
                            withCredentials: true
                        },
                        success: function (response) {
                            renderLayout(response);
                            deferred.resolve(response);
                        },
                        error: function (err) {
                            deferred.reject(err);
                        }
                    });
                });
                return deferred.promise();
            }
        }
        //=====product description UI===============
        var renderProductDescUI = function (templateUrl, data) {
            function execIconlistSlick() {
                $(".rl-slide-icon").slick({
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    autoplaySpeed: 3000,
                    arrows: true,
                    dots: true,
                    infinite: true,
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                            }
                        },
                        {
                            breakpoint: 900,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                            },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 6,
                                slidesToScroll: 6
                            }
                        },
                        {
                            breakpoint: 580,
                            settings: {
                                slidesToShow: 5,
                                slidesToScroll: 5
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 4
                            }
                        }
                        
                    ]
                });
            }   

            $.get(templateUrl, function (response) {
                _productdesc.html(response);
                $("._productdesc-title").html(data.CSItem.Name.toUpperCase());
                data.CSItem.Description = data.CSItem.Description.replace(new RegExp('\r\n', 'g'), '<br>').replace(new RegExp('&lt;', 'g'), '<').replace(new RegExp('&gt;', 'g'), '>');
                $("._productdesc-desc").html(data.CSItem.Description);
                $("._productdesc-iconlist").append(renderIconListUI(data)).promise().done(function() {
                    execIconlistSlick();
                });
                $("._productdesc-artist").append(renderProductDescArtistUI(data));
                $("._productdesc-packinclude-item").append(renderPackIncludeUI(data));
                renderProductDescNoteUI(data);

                $("._productdesc").removeClass("rl-hidden");
                $("._productdesc-area").removeClass("rl-hidden");
                global.rlModule.grid();
                if ($("._productdesc-packinclude-item").html() !== '') {
                    $("._productdesc-packinclude").removeClass("rl-hidden");
                } else {
                    $("._packdetail-grid .rl-flex-space").addClass("rl-hidden");
                }
                
                $("._rl-toggle-title")
                .css('cursor', 'pointer')
                .on('click', function() {
                    $(this).parent().find("._rl-toggle-item").slideToggle();
                    $(this).toggleClass('open');
                })
            });
        }

        var renderProductDescNoteUI = function (data) {
            //hidden condition
            var deferred = $.Deferred();

            if ((data.DisplayBaseRequireItem.length > 0) || (data.CCDDisplayPack.length > 0) || (data.BaseRequirePack.length > 0) || (data.DisplayDRMRequiredItem.length > 0)) {

                var productDescNoteItem1 = '';
                var productDescNoteItem2 = '';
                var productDescNoteItem3 = '';
                $("._productdesc-note").removeClass("rl-hidden"); //show note

                if (data.DisplayBaseRequireItem.length > 0) {
                    productDescNoteItem1 = productDescNoteItem1 + 'Some items in the pack require base models for them to function properly. If you do not have the following base contents, you may get incorrect results.<br><br>You could purchse these item(s) from the Marketplace:<br><br>';

                    for (var i = 0; i < data.DisplayBaseRequireItem.length; i++) {
                        var displayBaseRequireItem = data.DisplayBaseRequireItem[i];
                        var productDescNoteItem1_p1 = '';
                        var productDescNoteItem1_p2 = '';
                        productDescNoteItem1 = productDescNoteItem1 + '<span>';
                        for (var j = 0; j < displayBaseRequireItem.RequireItems.length; j++) {
                            var requireItems = displayBaseRequireItem.RequireItems[j];
                            var needComma = ((j + 1) != displayBaseRequireItem.RequireItems.length) ? '<span> , </span>' : '';

                            productDescNoteItem1_p1 = productDescNoteItem1_p1 + '<span><a href="' + requireItems.Url + '" class="theme-link2" target="_blank">' + requireItems.Name + '</a>' + needComma + '</span>';
                        }

                        if (displayBaseRequireItem.RequirePacks.length > 0) {
                            productDescNoteItem1_p2 = productDescNoteItem1_p2 + '<span><br> To learn more about these items or to purchase related items for a better deal, please go to:<br>';
                            for (var k = 0; k < displayBaseRequireItem.RequirePacks.length; k++) {
                                var requiredpack = displayBaseRequireItem.RequirePacks[k];
                                var needComma = ((k + 1) != displayBaseRequireItem.RequirePacks.length) ? '<span> , </span>' : '';

                                productDescNoteItem1_p2 = productDescNoteItem1_p2 + '<span><a href="' + requiredpack.Url + '" class="theme-link2" target="_blank">' + requiredpack.Name + '</a>' + needComma + '</span>';
                            }
                            productDescNoteItem1_p2 = productDescNoteItem1_p2 + '</span><br><br>';
                        }

                        productDescNoteItem1 = productDescNoteItem1 + productDescNoteItem1_p1 + productDescNoteItem1_p2 + '</span>';
                    }
                    //productDescNoteItem1 = productDescNoteItem1 + '<br/><br/>';
                    $("._productdesc-notetext-1").html(productDescNoteItem1);
                }
                if (data.BaseRequirePack.length > 0) {
                    productDescNoteItem2 = productDescNoteItem2 + 'Some items in this pack require base models that can only find in content packs to function correctly. If you do not have the following base contents you may get incorrect results.<br /><br />The require models can be found in the following pack(s):<br />';
                    var productDescNoteItem2_p1 = '';
                    for (var i = 0; i < data.BaseRequirePack.length; i++) {
                        var baseRequirePack = data.BaseRequirePack[i];
                        var needComma = ((i + 1) != data.BaseRequirePack.length) ? '<span> , </span>' : '';

                        productDescNoteItem2_p1 = productDescNoteItem2_p1 + '<span><a href="' + baseRequirePack.Url + '" class="theme-link2" target="_blank">' + baseRequirePack.Name + '</a>' + needComma + '</span>';
                    }
                    productDescNoteItem2 = productDescNoteItem2 + productDescNoteItem2_p1;
                    $("._productdesc-notetext-2").html(productDescNoteItem2);
                }
                if ((data.CCDDisplayPack.length > 0) || (data.DisplayDRMRequiredItem.length > 0)) {
                    productDescNoteItem3 = productDescNoteItem3 + 'This is a derivative content from the following base content. Please make sure you have the base content for this content to function as a full version. A derivative content can not be uploaded for sale unless it is modified from a base content. ';

                    var productDescNoteItem3_p1 = '';
                    var productDescNoteItem3_p2 = '';
                    if (data.CCDDisplayPack.length > 0) {
                        for (var i = 0; i < data.CCDDisplayPack.length; i++) {
                            var ccdDisplayPack = data.CCDDisplayPack[i];
                            var needComma = ((i + 1) != data.CCDDisplayPack.length) ? '<span> , </span>' : '';

                            productDescNoteItem3_p1 = productDescNoteItem3_p1 + '<span><a href="' + ccdDisplayPack.Url + '" class="theme-link2" target="_blank">' + ccdDisplayPack.Name + '</a>' + needComma + '</span>';
                        }
                    }

                    if (data.DisplayDRMRequiredItem.length > 0) {
                        for (var i = 0; i < data.DisplayDRMRequiredItem.length; i++) {
                            var displayDRMRequiredItem = data.DisplayDRMRequiredItem[i];
                            var needComma = ((i + 1) != data.DisplayDRMRequiredItem.length) ? '<span> , </span>' : '';

                            productDescNoteItem3_p2 = productDescNoteItem3_p2 + '<span><a href="' + displayDRMRequiredItem.Url + '" class="theme-link2" target="_blank">' + displayDRMRequiredItem.Name + '</a>' + needComma + '</span>';
                        }
                    }

                    productDescNoteItem3 = productDescNoteItem3 + productDescNoteItem3_p1 + productDescNoteItem3_p2;
                    $("._productdesc-notetext-3").html(productDescNoteItem3);
                }

                //productDescNoteUI = productDescNoteItem1 + productDescNoteItem2 + productDescNoteItem3;
                //_productdesc-notetext-1
                deferred.resolve();
            }

            return deferred.promise();

        }

        var renderPackIncludeUI = function (data) {
            var packIncludeUI = '';

            for (var i = 0; i < data.IncludePack.length; i++) {
                packIncludeUI += `
                  <li class="rl-fontweight-regular rl-lineheight-12" style="color: #767676; font-size:18px">
                    ${data.IncludePack[i].Quantifier} (${data.IncludePack[i].Qty}) 
                    ${data.IncludePack[i].Description.length == 0 ? '' : `<br><span style="font-size: 12px; color: #b1b1b1">${data.IncludePack[i].Description}</span>`}
                  </li>`;
            }

            return packIncludeUI;
        }

        var renderProductDescArtistUI = function (data) {
            var productDescArtistUI = '';
            if (data.CSItem.FDAuthor != null && data.CSItem.FDAuthor.length > 0) {
                productDescArtistUI = '<a href="' + urlDomain + websiteName + 'FeaturedDeveloper/profile/#!/' + encodeURIComponent(data.CSItem.FDAuthor) + '" class="theme-link2 rl-text-h2 rl-fontweight-lighter" target="_self">' + data.CSItem.Author + '</a>';
            } else {
                productDescArtistUI = '<a href="' + urlDomain + websiteName + 'index.html?author=' + encodeURIComponent(data.CSItem.Author) + '&CategoryID=' + data.CSItem.CategoryID + '" class="theme-link2 rl-text-h2 rl-fontweight-lighter" target="_self">' + data.CSItem.Author + '</a>';
            }

            return productDescArtistUI;
        }

        var renderIconListUI = function(pageInfoData) {
            var processIconlist = function() {
                var processedIconList = [];

                if (pageInfoData.PageType != pageType.ct) {
                    var tempIconList = pageInfoData.IconList;

                    var pushIconListItem = function(tempIconList ,name, imgName, pathName) {
                        tempIconList.push({
                            Name: name, 
                            IconImage: pageInfoData.IconPath + imgName,
                            IconImageLink: pathName,
                            Type: iconListTypeEnum.SPEC,
                        });
                    }
                    
                    if (pageInfoData.PageType == pageType.aud) {
                        pushIconListItem(tempIconList, "Audio", "icon_audio.gif", "content/spec/?p=ic#IC-Audio");
                    }
                    else {
                        if (pageInfoData.PageType != pageType.cta) {
                            switch (pageInfoData.PolySize) {
                                case modelPolygonSizeEnum.LOW:
                                    pushIconListItem(tempIconList, "Model Polygon Size - Low", "IC-Pro-Low.svg", "content/spec/?p=ic#IC-Pro-Low");
                                    break;
                                case modelPolygonSizeEnum.MID:
                                    pushIconListItem(tempIconList, "Model Polygon Size - Mid", "IC-Pro-Mid.svg", "content/spec/?p=ic#IC-Pro-Mid");
                                    break;
                                case modelPolygonSizeEnum.HIGH:
                                    pushIconListItem(tempIconList, "Model Polygon Size - High", "IC-Pro-Hi.svg", "content/spec/?p=ic#IC-Pro-Hi");
                                    break;
                            }

                            switch (pageInfoData.Resolution) {
                                case textureResolutionEnum.LOW:
                                    pushIconListItem(tempIconList, "Texture Resolution - Low", "IC-Res-Low.svg", "content/spec/?p=ic#IC-Res-Low");
                                    break;
                                case textureResolutionEnum.MID:
                                    pushIconListItem(tempIconList, "Texture Resolution - Mid", "IC-Res-Mid.svg", "content/spec/?p=ic#IC-Res-Mid");
                                    break;
                                case textureResolutionEnum.HIGH:
                                    pushIconListItem(tempIconList, "Texture Resolution - High", "IC-Res-Hi.svg", "content/spec/?p=ic#IC-Res-Hi");
                                    break;
                            }
                        }
                    }

                    var nonExportableNote = tempIconList.some(icon =>icon.Type === iconListTypeEnum.SPEC && icon.IconImage !== null && icon.Name === 'IC-Non-Exportable') 
                        ? `
                            <p class="rl-fontweight-regular rl-lineheight-15 rl-row-top-calc-10" style="font-size: 12px; color: #b1b1b1;">
                                *Please note that this content includes non exportable content which can only be used within Reallusion applications. See 
                                <a href="/content/spec/default.html#IC-Non-Exportable" class="theme-link2" style="font-size: inherit;" target="_blank">Content Specifications</a>.
                            </p>
                        `
                        : '';
                    
        
                    processedIconList = [{
                        title: "Content spec：",
                        icons: tempIconList.filter(icon => icon.Type === iconListTypeEnum.SPEC && icon.IconImage !== null),
                        note: nonExportableNote
                    }, {
                        title: "Attribute：",
                        icons: tempIconList.filter(icon => icon.Type === iconListTypeEnum.ATTRIBUTE && icon.IconImage !== null)
                    }];
                }
                else {
                    processedIconList = [];
                }

                return processedIconList;
            }

            var iconListUI = processIconlist(pageInfoData).reduce((result, iconlist, index) => {
                if (iconlist.icons.length > 0) {
                    result += `
                        ${(result != '' && (index % 2 === 1))? '<div class="rl-line-iconlist-wrapper"><div class="rl-line-iconlist"></div></div>' : ''}
                        <div class="icon-list grid-item"> 
                            <div class="rl-fontweight-regular rl-lineheight-12 rl-row-bottom-20 product-desc-title">${iconlist.title}</div>
                                <div class="rl-slide-icon">
                                    ${iconlist.icons.map(iconItem => `
                                        <a href="${rlServerURL.MainWeb + (iconItem.IconImageLink || 'content/spec/')}" title="${iconItem.Name}" target="_blank">
                                            <img src="${rlServerURL.MainWeb + iconItem.IconImage}" alt="${iconItem.Name}" class="img-responsive">
                                        </a>
                                    `).join('')}
                                </div>
                            ${iconlist.note ? iconlist.note : ''}
                        </div>
                    `
                }

                return result
            }, '');

            return iconListUI;
        }

        //===== End of product description UI===============

        //=====product price UI===============
        var renderProductPriceUI = function (templateUrl, data) {
            var urlAddFrom = getURLParameter('addfrom');
            var buyLinkAddFrom = '';
            if (urlAddFrom !== null && urlAddFrom !== '') {
                buyLinkAddFrom = '&addfrom=' + urlAddFrom;
            }
            else if ($(".rl-contentpackprice[data-add-from]").length > 0) {
                buyLinkAddFrom = '&addfrom=' + $(".rl-contentpackprice").data("add-from");
            }
            $.get(templateUrl, function (response) {
                var authorLink;
                var pageType = {
                    "ic": 0,
                    "ct": 1,
                    "aud": 2,
                    "cta": 3,
                    "cc": 4
                }
                if ($(`[data-content-pid=${data.CSItem.ContentID}] ._productprice`).length) {
                    _productprice = $(`[data-content-pid=${data.CSItem.ContentID}] ._productprice`);
                }
                var isHidePackInfo =  _productprice.parent().attr("hide-pack-info") === "";
                var isShowKnowMoreButton =  _productprice.parent().attr("show-know-more-button") === "";

                _productprice.html(response);
                setWishListIconState(pageInfoData.CSItem.InWishList);
                _productprice.find("#share-url-input").val(window.location.href);
                _productprice.find(".contentpack-packname .value").text(data.CSItem.Name);

                //Binding Author
                if (data.CSItem.FDAuthor != null && data.CSItem.FDAuthor != '') {
                    authorLink = "/contentstore/FeaturedDeveloper/profile/#!/";
                    _productprice.find(".contentpack-author .value a").attr({ title: data.CSItem.FDAuthor, href: authorLink + encodeURIComponent(data.CSItem.FDAuthor) }).text(data.CSItem.Author);
                }
                else {
                    authorLink = "/contentstore/index.html?Author=";
                    _productprice.find(".contentpack-author .value a").attr({ title: data.CSItem.Author, href: authorLink + encodeURIComponent(data.CSItem.Author) + '&CategoryID=' + data.CSItem.CategoryID }).text(data.CSItem.Author);
                }

                //Breadcrumb
                let result = [];
                let node = data.LocationBar.SubItem
                while (node) {
                    result.push({ Name: node.Name, Url: node.Url });
                    node = node.SubItem;
                }

                if (result.at(-1).Name.trim() === result.at(-2).Name.trim()) {
                    result.pop();
                }

                const $breadcrumbContainer = _productprice.find('.contentpack-breadcrumb .value');
                $breadcrumbContainer.empty();

                const breadcrumbHtml = result.map(({ Name, Url }) => {
                    if (Url) {
                        return `<a class="breadcrumb-link" href="${Url}" target="_self" title="${Name}">${Name}</a>`;
                    } else {
                        return `<span class="breadcrumb-text">${Name}</span>`;
                    }
                }).join('<span class="breadcrumb-pattern">\u00A0>\u00A0</span>');

                $breadcrumbContainer.append(breadcrumbHtml);



                //Binding Required Info
                const $requiredInfo = _productprice.find(".contentpack-profile");
                const $divideline = _productprice.find(".mobile-col-one .theme-divideline");
                if (textInfo.requiredVersionText) {
                    $requiredInfo.show();
                    $divideline.show();
                    _productprice.find(".contentpack-profile-required").text(textInfo.requiredVersionText)
                } else {
                    $requiredInfo.hide();
                    $divideline.hide();
                }
                //View pack items link
                if (_productdesc.length > 0 && data.IncludePack.length > 0) {
                    _productprice.find(".contentpack-view-pack-items").removeClass("rl-hidden");
                    _productprice.find(".contentpack-view-pack-items").on('click', function() {
                        setTimeout(function() {
                            $("html, body").animate({
                                scrollTop: $("._productdesc-packinclude").offset().top + $("._productdesc-packinclude").outerHeight() - 0.5 * $(window).height()
                            }, 500)
                        }, 10)
                    });
                }
                
                if (isHidePackInfo) {
                    _productprice.find(".contentpack-item-container .contentpack-profile").hide();
                    _productprice.find(".contentpack-line").hide();
                }

                //Binding Price Area
                function setAddToCartButton($el, data, addFrom) {
                    const link = `${data.CSItem.Buylink}${addFrom}`;

                    if (data.DisplayBaseRequireItem.length > 0 || data.CCDDisplayPack.length > 0 || data.BaseRequirePack.length > 0 || data.DisplayDRMRequiredItem.length > 0) {
                        $el.parent("a").off('click.addToCart');
                        $el.parent("a").on('click.addToCart', function(event) {
                            event.preventDefault();
                            magnificDialog(
                                'Base Content Required for Full Functionality! To avoid having watermark, you need to purchase base content on product page.',
                                '',
                                [{text: 'OK', returnCode: 'ok'}]
                            ).then(returnCode => {
                                location.href = link;
                            }) ;
                        })
                    }

                    $el.parent("a").attr("href", link);
                }

                function setPriceArea(data) {
                    const displayPrice = data.CSItem.Price;
                    const displayListPrice = data.CSItem.ListPrice;

                    if (displayPrice != null) {
                        _productprice.find(".contentpack-price .price").text(padDecimal(displayPrice));
    
                        if (displayListPrice != displayPrice) {
                            var percent = Math.round((displayListPrice - displayPrice) / displayListPrice * 100);
                            _productprice.find(".contentpack-price .percent-off").text(`${percent}% OFF`);
                            _productprice.find(".contentpack-price .list-price").text(padDecimal(displayListPrice));
                            _productprice.find(".contentpack-price .discount-info").show();
                        }
                        else {
                            _productprice.find(".contentpack-price .discount-info").hide();
                        }
    
                        if ((data.CSItem.VisibilityId == null) || (data.CSItem.VisibilityId == 0)) {
                            setAddToCartButton(_productprice.find(".contentpack-price .btn-buy"), data, buyLinkAddFrom);
                            _productprice.find(".contentpack-price .btn-buy").show();
                        }
                        else {
                            _productprice.find(".contentpack-price .btn-buy").hide();
                        }
                    }
                }

                setPriceArea(data);

                if (data.CSItem.DisplayMessageType !== displayMessageTypeForDiscontinuedContentEnum.SHOW_DEFAULT_MESSAGE) {
                    _productprice.find(".contentpack-price").show();
                }
                
                if ((data.CSItem.Price != null && data.CSItem.Price == 0) && (data.PageType == pageType.ic)) {
                    _productprice.find(".contentpack-note").show();
                }

                if (data.CSItem.DisplayMessageType === displayMessageTypeForDiscontinuedContentEnum.SHOW_DEFAULT_MESSAGE) {
                    _productprice.find(".promotion-container .promotion-title-wrapper").text("Sorry. The link you followed is no longer available. Go back to Content Store to check further the latest products.");
                    _productprice.find(".promotion-container .promotion-endDate-wrapper").hide();
                    fitText("._productprice .promotion-container .promotion-title-wrapper" ,2);

                    //show previous purchased button
                    _productprice.find(".previous-purchased-container").removeClass("rl-hidden");
                    _productprice.find(".previous-purchased-container a").click(function(e) {
                        e.preventDefault();
                        if (_productdesc) {
                            $("html, body").animate(
                                {
                                    scrollTop: _productdesc.offset().top
                                },
                                1000
                            );
                        }
                    })
                }
                else if (data.CSItem.DisplayMessageType !== displayMessageTypeForDiscontinuedContentEnum.HIDDEN) {
                    //Binding Promotion Info
                    if (data.CSItem.PromotionName) {
                        if (data.CSItem.PromotionURL) {
                            _productprice.find(".promotion-container").attr({"href":data.CSItem.PromotionURL, "target":"_blank"});
                        }
                        _productprice.find(".promotion-container .promotion-title-wrapper").html(data.CSItem.PromotionName);
                    }
                    if (data.CSItem.PromotionEndDate) {
                        const date = new Date(data.CSItem.PromotionEndDate);
                        const promotionEndDate = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' }).format(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
                        fitText("._productprice .promotion-container .promotion-title-wrapper" ,2);
                        _productprice.find(".promotion-container .promotion-endDate-wrapper").find(".date").text(promotionEndDate + " ( UTC )");
                    }
                    else {
                        _productprice.find(".promotion-container .promotion-endDate-wrapper").hide();
                    }
                    if (!data.CSItem.PromotionName && !data.CSItem.PromotionEndDate) {
                        _productprice.find(".promotion-container").hide();
                    }
                }
                else {
                    _productprice.find(".promotion-container").hide();
                }

                //Binding Know More Link
                if (data.CSItem.ProductLink != "" && isShowKnowMoreButton) {
                    _productprice.find(".know-more-container a").attr("href", data.CSItem.ProductLink);
                }
                else {
                    _productprice.find(".know-more-container").hide();
                }
               
                global.rlModule.grid();

                setTimeout(function(){
                    scalePriceContainerByWindowResize();
                    shiftPriceAreaWhenScroll();
                }, 0);
                $(window).on("resize", function () {
                    scalePriceContainerByWindowResize();
                });
            });
        }

        //=====End of product price UI===============
        var scalePriceContainerByWindowResize = function () {
            var maxWidth = $('.rl-contentpackprice').width();
            var windowSize = window.innerWidth;
            var ratio = (maxWidth * 1920) / windowSize;
            var scale = maxWidth / ratio;

            if (windowSize <= 767) {
                $('.rl-contentpackprice').css({
                    '-webkit-transform': '',
                    '-ms-transform': '',
                    'transform': '',
                    '-webkit-transform-origin': '',
                    '-ms-transform-origin': '',
                    'transform-origin': ''
                });
            }
            else {
                scale = Math.min(1.0, scale);
                scale = Math.max(0.5, scale);
                $('.rl-contentpackprice').css({
                    '-webkit-transform': 'scale(' + scale + ')',
                    '-ms-transform': 'scale(' + scale + ')',
                    'transform': 'scale(' + scale + ')',
                    '-webkit-transform-origin': 'top',
                    '-ms-transform-origin': 'top',
                    'transform-origin': 'top',
                });
            }
        }

        var padDecimal = function (number) {
            number = '' + number;
            var decimalNumber = number.split(".");
            if (decimalNumber.length == 2) {
                return decimalNumber[0] + "." + padRight(decimalNumber[1], 2);
            }
            return decimalNumber[0] + "." + padRight('', 2);
        }

        var padRight = function (str, len) {
            str = '' + str;
            if (str.length >= len) {
                return str;
            } else {
                return padRight(str + "0", len);
            }
        }

        var _loadScript = function () {
            var deferred = $.Deferred();
            var _scriptServerUrl = (location.protocol + "//" + location.hostname).toLowerCase().replace(/(^http.*:\/\/(.+\-)*)(.*?\.).*/, "$1www.reallusion.com/");
            
            $.getScript(_scriptServerUrl + _rlServerConfigPath)
                .then(function () {
                    var _loadQueue = _requiredFilePaths.map(function (path) {
                        return $.getScript(rlServerURL.MainWeb + path);
                    });

                    _loadQueue.push($.Deferred(function (defer) {
                        $(defer.resolve);
                    }));

                    $.when.apply(null, _loadQueue).done(function () {
                        deferred.resolve();
                    }).fail(function () {
                        deferred.reject('load required js fail.');
                    });
                }).fail(function () {
                    deferred.reject('load rlServer config fail.');
                });

            return deferred.promise();
        };

        var fitText = function (elementSelector, lineClamp = 2) {
            var targets = $(elementSelector);
            var timer;
            var originCss = {};
            var updateTextFontSize = function (target, fontSize = 16, lastScrollHeight = 0) {
                target.css({
                    "display": "-webkit-box",
                    "-webkit-box-orient": "vertical",
                    "-webkit-line-clamp": String(lineClamp),
                    "overflow": "hidden",
                    "font-size": fontSize + "px"
                });
                var offsetHeight = target[0].offsetHeight;
                var scrollHeight = target[0].scrollHeight;
                var titleLineHeight = parseInt(target.css("line-height"));
                if (((scrollHeight - offsetHeight) >= titleLineHeight) && scrollHeight != lastScrollHeight) {
                    updateTextFontSize(target, fontSize - 1, scrollHeight);
                }
                else if (scrollHeight == lastScrollHeight) {
                    target.css(originCss);
                }
            }

            if (targets.length > 0) {
                targets.each(function () {
                    if ($(this).text() != "" && $(this).css("display") != "none") {
                        originCss.display = $(this).css("display");
                        originCss.overflow = $(this).css("overflow");
                        var initialFontSize = parseInt($(this).css("font-size"));
                        updateTextFontSize($(this), initialFontSize);
                        const vm = this;
                        $(global).resize(function () {
                            clearTimeout(timer);
                            timer = setTimeout(function () {
                                updateTextFontSize($(vm), initialFontSize)
                            }, 100);
                        });
                    }
                });
            }
        }

        _module.copyShareLink = function() {
            let textToCopy = document.querySelector('#share-url-input').value;
            navigator.clipboard.writeText(textToCopy);
        }

        _module.closeSharePanel = function() {
            $.magnificPopup.close();
        }

        function magnificDialog(message, title, buttons) {
            return new Promise(function(resolve, reject) {
                $.magnificPopup.open({
                    items: {
                        src: `
                            <div class="magnific-dialog">
                                <div class="title">${title}</div>
                                <div class="content">${message}</div>
                                <div class="btns"></div>
                            </div>
                        `,
                        type: 'inline',
                    },
                    closeOnBgClick: false,
                    callbacks: {
                        open: function() {
                            buttons.map((button, index) => {
                                const btn = $(`<button class="${index == 0 ? 'primary' : ''}">${button.text}</button>`);
                                btn.click(function() {
                                    $.magnificPopup.proto.close.call(this)
                                    resolve(button.returnCode);
                                });
                                $(this.content).find('.btns').append(btn);
                            });
        
                            $(this.content).find('.mfp-close').click(function(){
                                resolve('close');
                            }); 
                        }
                    }
                });
            });
        };
        
        _module.getRequiredVersionAndBuyButtonText = function(packData){
            let extraInfo = {};

            function requiredVersion(packData) {
                const csRequiredVersions = packData.RequiredVersions;
                const hasCsRequiredVersions = csRequiredVersions && csRequiredVersions.length > 0;
                let requireVersionList = [];

                const getCategoryName =(category) => {
                    let categoryName;
                    switch (category) {
                        case "ic":
                        case "iclone":
                            categoryName = "iC";
                            break;
                        case "cta":
                        case "cartoon animator":
                            categoryName = "CTA";
                            break;
                        case "cc":
                        case "character creator":
                            categoryName = "CC";
                            break;
                        case "ct":
                        case "crazytalk":
                            categoryName = "CT";
                            break;
                        case "media":
                            categoryName = "Popvideo";
                            break;
                        case "wc":
                            categoryName = "WidgetCast";
                            break;
                        case "crossap":
                            categoryName = "Cross Product";
                            break;
                    }

                    return categoryName;
                }

                const versionFormat = version => 'v' + (version / 100).toFixed(2);

                const getVersion = (versionInfo) => {
                    const { BeginVersion, EndVersion, PluginVersion } = versionInfo;
                    let version = '';
                    if (PluginVersion) {
                        version = PluginVersion.map((versionNumber) => versionFormat(versionNumber)).join(
                            ', '
                        );
                    } else if (BeginVersion && EndVersion) {
                        version =
                            versionFormat(versionInfo.BeginVersion) +
                            ' to < ' +
                            versionFormat(versionInfo.EndVersion);
                    } else if (BeginVersion) {
                        version = versionFormat(versionInfo.BeginVersion) + ' or above';
                    } else if (EndVersion) {
                        version = 'below ' + versionFormat(versionInfo.EndVersion);
                    }
                    return version;
                }
            
                if (packData.MKPInfo) {
                    const mkpRequiredVersions = packData.MKPInfo.RequireOneOfProduct;
                    const hasmkpRequiredVersions = mkpRequiredVersions && mkpRequiredVersions.length != 0;

                    if (hasmkpRequiredVersions && (!hasCsRequiredVersions || mkpRequiredVersions.length >= csRequiredVersions.length)) {
                        requireVersionList = mkpRequiredVersions.reduce((result, item) => {
                            const productCategory = getCategoryName(item.CategoryID) + ' ';

                            if (productCategory) {
                                result.push(productCategory + getVersion(item));
                            }
                            
                            return result;
                        }, [])
                    }
                }

                if (requireVersionList.length === 0 && hasCsRequiredVersions) {
                    requireVersionList = csRequiredVersions.reduce((result, requiredVersion) => {
                        const productType = getCategoryName(requiredVersion.CategoryName.toLowerCase());

                        if (productType) {
                            result.push(
                                productType
                                + ' ' + requiredVersion.VersionName
                                + (requiredVersion.VersionOnly ? " only" : " or above")
                                + (requiredVersion.Description.length > 0 ? ` (${requiredVersion.Description})` : '')
                            )
                        }

                        return result
                    }, []);
                }

                return requireVersionList.length > 0 ? requireVersionList.join("; ") + '.' : '';
            }

            if (packData) {
                extraInfo = {
                    requiredVersionText: requiredVersion(packData),
                    buyIcontentButtonText: 'Add to Cart',
                    buyExportButtonText: 'Add to Cart'
                }
            }

            return extraInfo;
        }

        _module.shareLink = function(type) {
            const _url = window.location.href;
            switch (type) {
                case "fb":
                    window.open(`https://www.facebook.com/sharer.php?u=${encodeURIComponent(_url)}`);
                    break;
                case "twitter":
                    window.open(`https://twitter.com/share?url=${encodeURIComponent(_url)}&text=${pageInfoData.CSItem.Name} in Content Store`);
                    break;
            }
        }
        
        return _module;
    })();

})(window);